import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px;
  background-color: white;
`;

const borderRadius = '3px';

export const Footer = styled(Content)`
  border-bottom-left-radius: ${borderRadius};
  border-bottom-right-radius: ${borderRadius};
`;

export const MvpDesignFooter = styled.div`
  gap: 8px;
`;
